export const calculateTotals = (expenses, currencyView = 'BaseCurrency') => {
  let income = 0;
  let expense = 0;
if(expenses?.length>0){
  expenses.forEach((exp) => {
    const value = currencyView === 'BaseCurrency' ? exp.amount / exp.conversionRate : exp.amount;
    exp.type === 'income' ? (income += value) : (expense += value);
  });
}

  const netProfit = income - expense;
  return { income, expense, netProfit };
};
